// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: #2b8c52;
}
ion-content.checkin-modal--checked-in {
  --background: #d3354a;
}
ion-content.checkin-modal--check-in-done {
  --background: #2b8c52;
}

.checkin-modal__close {
  position: absolute;
  top: 12px;
  right: 12px;
  z-index: 10;
}
.checkin-modal__close ion-button {
  --color: rgba(255, 255, 255, 0.85);
  --padding-start: 8px;
  --padding-end: 8px;
  font-size: 28px;
}

.checkin-modal__container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100%;
  padding: 48px 32px 40px;
  text-align: center;
  color: #ffffff;
  gap: 8px;
}

.checkin-modal__icon ion-icon {
  font-size: 120px;
  color: #ffffff;
  filter: drop-shadow(0 4px 16px rgba(0, 0, 0, 0.15));
}

.checkin-modal__status {
  margin-top: 8px;
}
.checkin-modal__status h2 {
  font-size: 22px;
  font-weight: 700;
  margin: 0;
  color: #ffffff;
}

.checkin-modal__time {
  font-size: 16px;
  opacity: 0.9;
  margin: 4px 0 0;
}

.checkin-modal__info {
  margin-top: 24px;
  width: 100%;
}
.checkin-modal__info h1 {
  font-size: 28px;
  font-weight: 700;
  margin: 0 0 8px;
  color: #ffffff;
}

.checkin-modal__detail {
  font-size: 20px;
  opacity: 0.9;
  margin: 4px 0;
  color: #ffffff;
}

.checkin-modal__type {
  display: inline-block;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  padding: 4px 14px;
  font-size: 14px;
  margin-top: 8px;
}

.checkin-modal__action {
  margin-top: 32px;
  width: 100%;
}
.checkin-modal__action ion-button {
  --border-color: rgba(255, 255, 255, 0.8);
  --color: #ffffff;
  --border-radius: 12px;
  font-size: 17px;
  font-weight: 600;
  height: 52px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/global/event-checkin-modal/event-checkin-modal.page.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;AACF;AACE;EACE,qBAAA;AACJ;AAEE;EACE,qBAAA;AAAJ;;AAIA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,WAAA;AADF;AAGE;EACE,kCAAA;EACA,oBAAA;EACA,kBAAA;EACA,eAAA;AADJ;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;AAFF;;AAME;EACE,gBAAA;EACA,cAAA;EACA,mDAAA;AAHJ;;AAOA;EACE,eAAA;AAJF;AAME;EACE,eAAA;EACA,gBAAA;EACA,SAAA;EACA,cAAA;AAJJ;;AAQA;EACE,eAAA;EACA,YAAA;EACA,eAAA;AALF;;AAQA;EACE,gBAAA;EACA,WAAA;AALF;AAOE;EACE,eAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AALJ;;AASA;EACE,eAAA;EACA,YAAA;EACA,aAAA;EACA,cAAA;AANF;;AASA;EACE,qBAAA;EACA,oCAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;AANF;;AASA;EACE,gBAAA;EACA,WAAA;AANF;AAQE;EACE,wCAAA;EACA,gBAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AANJ","sourcesContent":["ion-content {\n  --background: #2b8c52; // green — ready to check in\n\n  &.checkin-modal--checked-in {\n    --background: #d3354a; // danger red — already checked in\n  }\n\n  &.checkin-modal--check-in-done {\n    --background: #2b8c52;\n  }\n}\n\n.checkin-modal__close {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  z-index: 10;\n\n  ion-button {\n    --color: rgba(255, 255, 255, 0.85);\n    --padding-start: 8px;\n    --padding-end: 8px;\n    font-size: 28px;\n  }\n}\n\n.checkin-modal__container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 100%;\n  padding: 48px 32px 40px;\n  text-align: center;\n  color: #ffffff;\n  gap: 8px;\n}\n\n.checkin-modal__icon {\n  ion-icon {\n    font-size: 120px;\n    color: #ffffff;\n    filter: drop-shadow(0 4px 16px rgba(0, 0, 0, 0.15));\n  }\n}\n\n.checkin-modal__status {\n  margin-top: 8px;\n\n  h2 {\n    font-size: 22px;\n    font-weight: 700;\n    margin: 0;\n    color: #ffffff;\n  }\n}\n\n.checkin-modal__time {\n  font-size: 16px;\n  opacity: 0.9;\n  margin: 4px 0 0;\n}\n\n.checkin-modal__info {\n  margin-top: 24px;\n  width: 100%;\n\n  h1 {\n    font-size: 28px;\n    font-weight: 700;\n    margin: 0 0 8px;\n    color: #ffffff;\n  }\n}\n\n.checkin-modal__detail {\n  font-size: 20px;\n  opacity: 0.9;\n  margin: 4px 0;\n  color: #ffffff;\n}\n\n.checkin-modal__type {\n  display: inline-block;\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 20px;\n  padding: 4px 14px;\n  font-size: 14px;\n  margin-top: 8px;\n}\n\n.checkin-modal__action {\n  margin-top: 32px;\n  width: 100%;\n\n  ion-button {\n    --border-color: rgba(255, 255, 255, 0.8);\n    --color: #ffffff;\n    --border-radius: 12px;\n    font-size: 17px;\n    font-weight: 600;\n    height: 52px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
